/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RequestResetSyncItemsRequest
 */
export interface RequestResetSyncItemsRequest {
    /**
     *
     * @type {number}
     * @memberof RequestResetSyncItemsRequest
     */
    tenantId?: number;
    /**
     *
     * @type {number}
     * @memberof RequestResetSyncItemsRequest
     */
    userId?: number;
}

/**
 * Check if a given object implements the RequestResetSyncItemsRequest interface.
 */
export function instanceOfRequestResetSyncItemsRequest(value: object): value is RequestResetSyncItemsRequest {
    return true;
}

export function RequestResetSyncItemsRequestFromJSON(json: any): RequestResetSyncItemsRequest {
    return RequestResetSyncItemsRequestFromJSONTyped(json, false);
}

export function RequestResetSyncItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestResetSyncItemsRequest {
    if (json == null) {
        return json;
    }
    return {

        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function RequestResetSyncItemsRequestToJSON(json: any): RequestResetSyncItemsRequest {
    return RequestResetSyncItemsRequestToJSONTyped(json, false);
}

export function RequestResetSyncItemsRequestToJSONTyped(value?: RequestResetSyncItemsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

